const openTooltipButtons = document.querySelectorAll('.js-open-tooltip');

if (openTooltipButtons.length) {
  const closeTooltipButtons = document.querySelectorAll('.tooltip__close .button');
  const tooltips = document.querySelectorAll('.tooltip');
  const visible = 'tooltip--visible';

  // Open Tooltip
  const openTooltip = (event) => {
    const openTooltipButton = event.currentTarget;
    const nextTooltip = openTooltipButton.nextElementSibling;
    tooltips.forEach((tooltip) => {
      if (tooltip.classList.contains(visible)) {
        tooltip.classList.remove(visible);
      }
    });
    nextTooltip.classList.add(visible);
    event.stopPropagation();
    return false;
  };
  openTooltipButtons.forEach(button => button.addEventListener('click', openTooltip));

  // Close Tooltip
  const closeTooltip = (event) => {
    const closeTooltipButton = event.currentTarget;
    closeTooltipButton.closest('.tooltip').classList.remove(visible);
  };
  closeTooltipButtons.forEach(button => button.addEventListener('click', closeTooltip));

  // Click outside
  document.addEventListener('click', (event) => {
    const isOutside = !event.target.closest('.tooltip');
    if (isOutside) {
      tooltips.forEach(tooltip => tooltip.classList.remove(visible));
    }
  });
}
